import { pushToDataLayer } from '../../pushToDataLayer';
import { GTMEvent, GTMEventAttributes, GTMEventName } from '../../types';
import { VideoPlayerInteraction } from './types';

export function videoPlayerInteractionsEvent({
  action,
}: {
  action: VideoPlayerInteraction;
}) {
  const eventAttributes: GTMEventAttributes = {
    event: GTMEvent.COVIDEO_EVENT,
    event_name: GTMEventName.VIDEO_PLAYER_INTERACTION,
  };

  pushToDataLayer({
    ...eventAttributes,

    action,
  });
}
